import { Component, type ErrorInfo, type ReactNode } from 'react';
import { de } from '../i18n/de';

/**
 * Fängt unerwartete Darstellungsfehler ab, damit die Anwendung nicht komplett weiß bleibt. Mit `area` nur für einen Bereich (Erzähllinie,
 * Seitenleiste, ein Fenster …): Er zeigt dann einen kleinen Hinweis, der Rest der Geschichte bleibt bedienbar.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; area?: string; resetKey?: string }, { error: Error | null }> {
  override state = { error: null as Error | null };

  // anderer Inhalt (z. B. eine andere Auswahl in der Seitenleiste): neu versuchen
  override componentDidUpdate(prev: { resetKey?: string }): void {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Darstellungsfehler', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    if (this.props.area !== undefined) {
      return (
        <div className="notice danger error-area" role="alert" data-testid="error-area">
          <span className="grow">{de.errors.area(this.props.area)}</span>
          <button type="button" className="btn small" onClick={() => this.setState({ error: null })}>
            {de.common.retry}
          </button>
        </div>
      );
    }
    return (
      <div className="page col" role="alert">
        <h1>{de.errors.generic}</h1>
        <div className="muted">{this.state.error.message}</div>
        <div className="row">
          <button className="btn primary" onClick={() => this.setState({ error: null })}>
            {de.common.retry}
          </button>
          <button className="btn" onClick={() => (window.location.href = '/app')}>
            {de.toolbar.projects}
          </button>
        </div>
      </div>
    );
  }
}
